// The site-signed list of revoked customer licenses, as this browser last saw it (docs/features/licenses.md ›
// The two revocation lists): fetched once per page load from the website — a public file; the request carries no
// license, no cookie and nothing about a Mac — checked against a built-in list key, and kept in localStorage so
// an offline start still has the last one. An older list than the one kept is refused (`verifyList`'s `atLeast`).
// A list counts only when its key's mode is one this copy of the client takes (modes.js): on the real site a
// list signed with a test-mode list key is refused, fetched or kept, exactly as a test-mode license is.
//
// One seam: `lastSeenRevoked()` → the verified list, or null (no list key built in yet, nothing seen, offline
// with nothing kept, or a list of a mode not taken here). A license is then checked without a list — as a Mac
// that has never been online would. `loadRevoked` is the same with everything handed in (the tests run it).
import { verifyList } from '../core/license.js'
import { LICENSE_KEYS } from '../core/license-keys.js'
import { wwwOrigin } from '../core/site.js'
import { acceptedModes } from './modes.js'

const KEPT = 'cody.licenseRevoked'
let seen = null

export function lastSeenRevoked() {
  return (seen ||= loadRevoked({ keys: LICENSE_KEYS.lists || [], modes: acceptedModes(), storage: ownStorage(), fetch: (...a) => fetch(...a), origin: wwwOrigin }))
}
const ownStorage = () => { try { return globalThis.localStorage || null } catch { return null } }

export async function loadRevoked({ keys, modes, storage, fetch, origin }) {
  if (!keys.length) return null   // nothing could be checked: no list is taken on trust
  let kept = null
  try { kept = await verifyList(storage.getItem(KEPT), { keys, modes }) } catch { /* none kept, or not one this build takes */ }
  try {
    const answer = await fetch(origin() + '/.well-known/cody-license-revoked.json', { credentials: 'omit' })
    if (answer.ok) {
      const text = await answer.text()
      const fresh = await verifyList(text, { keys, modes, atLeast: kept?.version ?? 0 })
      try { storage.setItem(KEPT, text) } catch { /* private mode: this page load's copy only */ }
      return fresh
    }
  } catch { /* offline, or a list that does not check out: the kept one stands */ }
  return kept
}
